import _ from 'lodash';
const ROLE_FEATURES = Object.freeze({
  agent: ['externalAgentActions', 'internalAgentActions', 'viewLiveboards'],
  'agent-plus': ['customerAssigneeManagement', 'externalAgentActions', 'internalAgentActions', 'viewLiveboards'],
  'answers-admin': ['adminSettings', 'kbManagement'],
  'api-user': ['devManagement'],
  liveboards: ['viewLiveboards'],
  'task-user': ['internalAgentActions', 'viewLiveboards'],
  'team-manager': [
    'adminSettings',
    'externalAgentActions',
    'internalAgentActions',
    'customerAssigneeManagement',
    'inboxManagement',
    'kbManagement',
    'scheduledReportsManagement',
    'topicManagement',
    'viewLiveboards',
    'viewReports',

    'teamManagement',

    'groupInboxes',
    'viewAllGroupInboxes',
  ],
  'system-admin': [
    'adminSettings',
    'externalAgentActions',
    'internalAgentActions',
    'campaignsManagement',
    'channelManagement',
    'customerAssigneeManagement',
    'inboxManagement',
    'integrationsManagement',
    'ivrConfigurationManagement',
    'kbManagement',
    'rulesManagement',
    'topicManagement',
    'agentStatusManagement',
    'relationshipLabelsManagement',
    'agentConfigurationManagement',
    'scheduledReportsManagement',
    'sidekickConfigurationManagement',
    'viewLiveboards',
    'viewReports',

    'teamManagement',
    'userManagement',

    'groupInboxes',
    'viewAllGroupInboxes',

    'manageAttachments',
    'manageVoiceRecordings',
  ],
});

export default function createRoleFeatures(claims) {
  if (_.isEmpty(claims)) {
    return {};
  }

  let rolesFeatures = (claims.roleIds || [])
    .filter(roleId => ROLE_FEATURES[roleId])
    .reduce(
      (memo, roleId) => ROLE_FEATURES[roleId].reduce((memo, feature) => (memo[feature] = true) && memo, memo),
      {}
    );
  if (claims.ssoEnabled) {
    rolesFeatures['sso'] = true;
  }

  return rolesFeatures;
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/configuration/create_role_features.js